<template>
  <div id="app-onboarding" class="view-wrapper" data-naver-offset="214" data-menu-item="#layouts-navbar-menu"
    data-mobile-item="#home-sidebar-menu-mobile" :class="{ 'is-pushed-full': $store.state.isSubmenuActive }">
    <div class="page-content-wrapper">
      <div class="page-content is-relative">
        <div class="page-title has-text-centered tabs-wrapper">
          <!-- Sidebar Trigger -->
          <sidebar />

          <div class="title-wrap">
            <h1 class="title is-4">Manage Tags </h1>
          </div>
          <toolbar />
        </div>

        <div class="datatable-toolbar">
          <div class="select">
            <select class="datatable-filter datatable-select form-control" data-filter="position"
              data-filter-type="default" v-model="perPage" @change="filterData">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          &nbsp;entries per page

          <div class="buttons">
            <div class="control mr-2">
              <input v-model="searchText" @keyup="filterData" class="input custom-text-filter" placeholder="Search..." />
              <div class="form-icon">
                <i data-feather="search"></i>
              </div>
            </div>
            <button class="button h-button is-primary is-elevated" @click="addEdit('add', '')">
              <span class="icon">
                <i aria-hidden="true" class="fas fa-plus"></i>
              </span>
              <span>Add</span>
            </button>
          </div>
        </div>

        <div class="page-content-inner">
          <!-- Datatable -->
          <div class="table-wrapper" data-simplebar>
            <table id="users-datatable" class="table is-datatable is-hoverable table-is-bordered">
              <thead>
                <tr>
                  <th>
                    <div class="control">#</div>
                  </th>
                  <th>Name</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <draggable v-model="tags" tag="tbody" @change="updateOrder">
                <tr data-id="0" v-for="(data, index) in this.tags" :key="data.id">
                  <td>
                    <div class="control">
                      {{ parseInt(perPage) * (currentPage - 1) + index + 1 }}
                    </div>
                  </td>
                  <td class="wrap">
                    <span class="
                                                                      has-dark-text
                                                                      dark-inverted
                                                                      is-font-alt is-weight-600
                                                                      rem-90
                                                                    ">
                      {{ data.name }}
                    </span>
                  </td>
                  <td>
                    <div class="field is-grouped">
                      <div class="control">
                        <div class="thin-switch" :class="data.is_active == 0 ? 'is-danger' : 'is-success'">
                          <input :id="'thin-switch' + index" class="input" type="checkbox" :checked="data.is_active == 1"
                            @click="updateStatusOrder(index, { 'is_active': data.is_active == 0 ? 1 : 0, 'tag_id': data.tag_id })" />
                          <label :for="'thin-switch' + index" class="slider"></label> {{
                            data.is_active == 0 ? "Inactive" : "Active"
                          }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="buttons">
                      <button class="
                                                                        button
                                                                        is-light is-circle
                                                                        hint--bubble hint--success hint--top
                                                                      " data-hint="Edit"
                        @click="addEdit('edit', index)">
                        <span class="icon is-small">
                          <span class="fa-fw select-all fas"></span>
                        </span>
                      </button>

                      <button @click="deleteTag(index)" class="
                                                                        button
                                                                        is-light is-circle
                                                                        hint--bubble hint--primary hint--top
                                                                      " data-hint="Delete">
                        <span class="icon is-small">
                          <span class="fa-fw select-all fas"></span>
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </draggable>
            </table>
            <div class="section-placeholder" v-if="this.tags.length == 0">
              <div class="placeholder-content">
                <img class="light-image" src="img/illustrations/placeholders/search-4.svg" alt="">
                <img class="dark-image" src="img/illustrations/placeholders/search-4-dark.svg" alt="">
                <h3 class="dark-inverted">No data to show</h3>
                <p>There is currently no data to show in this list.</p>
              </div>
            </div>
          </div>

          <div id="paging-first-datatable" v-if="this.tags.length != 0" class="
                                                            pagination
                                                            datatable-pagination
                                                            pagination-datatables
                                                            text-center
                                                          ">
            <pagination v-model="currentPage" :per-page="parseInt(perPage)" :records="total" @paginate="filterData" />
          </div>
        </div>
      </div>
    </div>
    <div id="add-edit-modal" class="modal h-modal" :class="{ 'is-active': this.show != 0 }">
      <div class="modal-background h-modal-close"></div>
      <div class="modal-content">
        <form id="tag-form" data-vv-scope="tag-form" v-on:submit.prevent="onSubmit('tag-form')">
          <div class="modal-card">
            <header class="modal-card-head">
              <h3>
                {{
                  this.type == "add" ? "Add Tag Details" : "Edit Tag Details"
                }}
              </h3>
              <button class="h-modal-close ml-auto" aria-label="close" type="button">
                <i class="lnil lnil-close" @click="show = 0;"></i>
              </button>
            </header>
            <div class="modal-card-body">
              <div class="form-body">
                <!--Fieldset-->
                <div class="form-fieldset">
                  <div class="columns is-multiline">
                    <div class="column is-12">
                      <div class="field">
                        <label>Tag Name *</label>
                        <div class="control has-validation" :class="{
                          'has-error': errors.has('tag-form.name'),
                        }">
                          <input type="text" class="input" name="name" v-model="tag.name" placeholder=""
                            v-validate="'required|min:2|max:50'" @input="checkName()" :class="{
                              input: true,
                              'is-danger': errors.has(
                                'tag-form.name'
                              ),
                            }" />

                          <span v-show="errors.has('tag-form.name')" class="error-text">{{
                            errors.first("tag-form.name")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-card-foot is-centered">
              <div class="buttons">
                <button type="button" @click="show = 0;" class="button h-button is-light is-dark-outlined">
                  <span class="icon">
                    <i class="lnir lnir-arrow-left rem-100"></i>
                  </span>
                  <span>Cancel</span>
                </button>
                <button type="submit" id="save-button" class="button h-button is-primary is-raised"
                  :class="{ 'is-loading': buttonloader['tag-form'] }">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template> 
<script>
import dataProcess from '../../util/dataProcess';
import draggable from "vuedraggable";
export default {
  name: "home",
  components: {
    draggable
  },
  data() {
    return {
      tags: [],
      bkTags: [],
      buttonloader: [],
      total: 0,
      importCsv: true,
      tag: {
        name: "",
        lang_id: this.$store.state.appLocale.langId,
        device: this.$store.state.appDevice.device
      },
      type: "",
      index: "",
      show: 0,
      currentPage: 1,
      searchText: "",
      perPage: 10
    };
  },
  created() {
    this.$store.state.isDetailLoading = false;
  },
  mounted() {
    this.getData();
  },

  beforeMount() { },

  methods: {
    updateOrder() {
      this.$store.state.isDetailLoading = true;
      dataProcess
        .postBulkData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/update_data/display", this.tags)
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.isDetailLoading = false;
          }
        });

    },
    getData() {
      this.$store.state.isDetailLoading = true;
      dataProcess
        .getData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/list")
        .then((response) => {
          if (response.status == 200) {
            if (response.data) {
              this.bkTags = response.data.data;
              this.filterData();
            }
            this.$store.state.isDetailLoading = false;
          } else {
            this.total = 0;
          }
        });
    },
    updateStatusOrder(index, data) {
      if (
        confirm(
          "Are You Sure, want to " +
          (data.is_active == 1 ? "activate " : "inactivate") +
          " this tag?"
        )
      ) {
        dataProcess
          .postData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/update_data", data)
          .then((response) => {
            if (response.status == 200) {
              this.tags[index].is_active = data.is_active;
              if (data.is_active == 1) {
                this.$notyf.success("Activated successfully");
              } else {
                this.$notyf.error("Inactivated successfully");
              }

              this.$store.state.isDetailLoading = false;
            }
          });
      }
    },
    previewFiles(event) {
      this.tag.tag_logo = event.target.files[0];
      this.tempObject = URL.createObjectURL(this.tag.tag_logo);
    },
    deleteTag(index) {
      if (confirm("Are You Sure, Want To delete this tag?")) {
        let data = this.tags[index];
        this.$store.state.isDetailLoading = true;
        dataProcess
          .deleteData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/destory/" + data.tag_id)
          .then((response) => {
            if (response.status == 200) {
              let index1 = this.bkTags.findIndex((el) => el.id == data.id);
              this.bkTags.splice(index1, 1);
              this.filterData();
              this.$notyf.success("Deleted successfully");
              this.$store.state.isDetailLoading = false;
            }
          });
      }
    },
    filterData() {
      let searchText = this.searchText.toLowerCase().trim();
      let filterdData;
      if (searchText != "") {
        filterdData = this.bkTags.filter(
          (el) =>
            (el.name && el.name.toLowerCase().indexOf(searchText) > -1)
        );
      } else {
        filterdData = this.bkTags;
      }


      this.total = filterdData.length;
      if (this.currentPage > 1) {
        let noOfPages = Math.ceil(this.total / parseInt(this.perPage));
        this.currentPage = noOfPages >= this.currentPage ? this.currentPage : noOfPages;
      }
      this.tags = filterdData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );

    },
    addEdit(type, index) {
      this.show = 1;
      this.type = type;
      if (type == "add") {
        this.tag = {
          name: "",
          lang_id: this.$store.state.appLocale.langId,
        device: this.$store.state.appDevice.device
        };
      } else {
        this.tag = { ...this.tags[index] };
      }
    },
    onSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        this.$notyf.dismissAll();
        if (result && this.tag.tag_logo != '') {
          this.$store.state.isDetailLoading = true;
          this.buttonloader[scope] = true;
          if (this.type == "add") {
            this.tag.createdby = this.$store.state.loginUserData.id;
            this.tag.updatedby = this.$store.state.loginUserData.id;
            dataProcess
              .postData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/store", this.tag)
              .then((response) => {
                if (response.status == 200) {
                  if (response.data) {
                    this.tag.id = response.data;
                    this.buttonloader[scope] = false;
                    this.show = 0;
                    this.$store.state.isDetailLoading = false;
                    this.$notyf.success("Tag user added successfully");
                    this.getData();
                  } else {
                    this.buttonloader[scope] = false;
                    this.show = 0;
                    this.$store.state.isDetailLoading = false;
                    this.$notyf.error("Error in inserting data");
                  }
                }
                if (response.status == 422 || response.status == 500) {
                  this.buttonloader[scope] = false;
                  this.show = 0;
                  this.$store.state.isDetailLoading = false;
                  this.$notyf.error(response.data);
                }
              });
          } else {
            let postData = { ...this.tag };
            dataProcess
              .postData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/tags/update", postData)
              .then((response) => {
                if (response.status == 200) {
                  if (response.data) {
                    let index1 = this.bkTags.findIndex(
                      (el) => el.id == this.tag.id
                    );
                    this.bkTags[index1] = response.data.data;
                    let index2 = this.tags.findIndex(
                      (el) => el.id == this.tag.id
                    );
                    this.tags[index2] = response.data.data;
                    this.buttonloader[scope] = false;
                    this.show = 0;
                    this.$store.state.isDetailLoading = false;
                    this.filterData();
                    this.$notyf.success("Tag user updated successfully");
                  } else {
                    this.buttonloader[scope] = false;
                    this.show = 0;
                    this.$store.state.isDetailLoading = false;
                    this.$notyf.error("Error in inserting data");
                  }
                }
                if (response.status == 422 || response.status == 500) {
                  this.buttonloader[scope] = false;
                  this.show = 0;
                  this.$store.state.isDetailLoading = false;
                  this.$notyf.error(response.data);
                }
              });
          }
        } else {
          this.buttonloader[scope] = false;
          this.$notyf.error("Correct form errors!!");
        }
      });
      this.filterData();
    },
    checkName() {
      console.log(this.tag.name);
      if (this.tag.name.trim() != "") {
        let index = this.bkTags.findIndex(it => it.name.trim().toLowerCase() == this.tag.name.trim().toLowerCase());
        console.log(index);
        if (index > -1) {
          if (this.type == "add") {
            this.$notyf.error(
              "Entered Tag name already exist in database!!"
            );
            this.tag.name = "";
          } else {
            if (this.bkTags[index].id != this.tag.id) {
              this.$notyf.error(
                "Entered Tag name already exist in database!!"
              );
              this.tag.name = "";
            }
          }
        }
      }
    },
    existAlready(el, i, resolve) {

      if (el.field1.trim() == '') {
        this.error.push('Row ' + (i + 1) + " -  Tag name is empty, it is required field");
        resolve('');
      }
      else {
        if (this.bkTags.findIndex(it => it.name.trim().toLowerCase() == el.field1.trim().toLowerCase()) > -1) {
          this.error.push('Row ' + (i + 1) + " - " + el.field1 + ' Tag name already exist in database!!');
        }
        else {
          this.importData.push("('" + el.field1 + "'," + 1 + ")");
        }
        resolve('');
      }

    },
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.getData();
    },
    '$store.state.appDevice': function (newVal, oldVal) {
      this.getData();
    }
  },
  metaInfo: {
    title: "Skiy31 :: Manage tags",
  },
};
</script>
<style>
.vue-csv-uploader-part-two {
  display: none;
}

.center-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
}

.file-input {
  height: auto;
}

#import-modal .column {
  padding: 0px;
}

.form-fieldset {
  padding: 20px 0;
  max-width: 480px;
  margin: 0 38px;
}
</style>